import customFetch from '../../../../utils/fetch';

export const TYPES = {
  GET_GENERATED_RESUME: 'resumeManagement/GET_GENERATED_RESUME',
  GET_GENERATED_RESUME_SUCCESS: 'resumeManagement/GET_GENERATED_RESUME_SUCCESS',
  GET_GENERATED_RESUME_ERROR: 'resumeManagement/GET_GENERATED_RESUME_ERROR',
  CLEAR_GENERATED_RESUME: 'resumeManagement/CLEAR_GENERATED_RESUME',
};

export const fetchGeneratedResume = (pdfURL, resumeID) => async (dispatch) => {
  dispatch({ type: TYPES.GET_GENERATED_RESUME, payload: { resumeID } });
  try {
    const response = await customFetch(pdfURL, {
      method: 'GET',
      fullResponse: true,
    });
    const blob = await response.blob();
    const pdfContent = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    dispatch({
      type: TYPES.GET_GENERATED_RESUME_SUCCESS,
      payload: { pdfContent, resumeID },
    });
  } catch (error) {
    dispatch({ type: TYPES.GET_GENERATED_RESUME_ERROR, payload: { resumeID, error } });
  }
};

export const headRequestPDF = pdfUrl => async () => {
  try {
    const response = await fetch(pdfUrl.split('?')[0], {
      mode: 'cors',
      method: 'HEAD',
      headers: new Headers({
        Origin: window.location.origin,
      }),
    });
    return response.headers;
  } catch (error) {
    return null;
  }
};

export const clearGeneratedResume = pdfUrl => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_GENERATED_RESUME, payload: { pdfUrl } });
};

export default {
  TYPES,
  fetchGeneratedResume,
  headRequestPDF,
  clearGeneratedResume,
};
